export const ALWAYS = 'always';
export const IF_NEEDED = 'if-needed';
